import { FC, PropsWithChildren } from "react";

/**
 * The indicators container component.
 */
export const IndicatorsContainer: FC<PropsWithChildren<{}>> = ({ children }) => {
  return <>{children}</>;
};
